import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import BaseImage from '../../../../../../atoms/Image';
import { IMAGE_LOAD_STRATEGIES, LAZY_LOAD_STRATEGY } from '../../../../../../atoms/Image/Image.constants';
import { ImagePropType } from '../../../../../../services/proptypes';
import { ChildrenPropType } from '../../../../../foundation/types/component';
import './Image.css';
var defaultProps = {
  as: 'div',
  src: '',
  background: false,
  altText: '',
  gatsbyImageProps: null,
  children: null,
  loadStrategy: LAZY_LOAD_STRATEGY
};
export default function Image(_ref) {
  var as = _ref.as,
    src = _ref.src,
    background = _ref.background,
    altText = _ref.altText,
    gatsbyImageProps = _ref.gatsbyImageProps,
    children = _ref.children,
    loadStrategy = _ref.loadStrategy;
  if (_isEmpty(src) && _isEmpty(children)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "image-container"
  }, /*#__PURE__*/React.createElement(BaseImage, {
    as: as,
    src: src,
    background: background,
    altText: altText,
    gatsbyImageProps: gatsbyImageProps,
    className: "image",
    loadStrategy: loadStrategy
  }, children));
}
Image.defaultProps = defaultProps;